import Fixed from './Fixed/Fixed';

const templates = {
  Fixed,
};

export default templates;
